import React from 'react';
const galleryImages = [{
  url: 'https://images.unsplash.com/photo-1511285560929-80b456fea0bc?w=600&q=80',
  alt: 'Outdoor ceremony setup'
}, {
  url: 'https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=600&q=80',
  alt: 'Reception hall'
}, {
  url: 'https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?w=600&q=80',
  alt: 'Garden pathway'
}, {
  url: 'https://images.unsplash.com/photo-1520854221256-17451cc331bf?w=600&q=80',
  alt: 'Evening venue lighting'
}, {
  url: 'https://images.unsplash.com/photo-1470229538611-16ba8c7ffbd7?w=600&q=80',
  alt: 'Venue exterior'
}, {
  url: 'https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=600&q=80',
  alt: 'Sunset view'
}];
export function GalleryPreview() {
  return <section id="gallery" className="py-20 sm:py-24 lg:py-32 bg-white" data-id="element-72">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-73">
        <div className="text-center mb-16" data-id="element-74">
          <h2 className="text-4xl sm:text-5xl font-serif font-bold text-black mb-4" data-id="element-75">
            Gallery
          </h2>
          <div className="w-16 h-px bg-gray-400 mx-auto mb-6" data-id="element-76"></div>
          <p className="text-gray-600 text-base max-w-2xl mx-auto" data-id="element-77">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do
            eiusmod tempor
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-78">
          {galleryImages.map((image, index) => <div key={index} className="relative aspect-square overflow-hidden group cursor-pointer" data-id="element-79">
              <img src={image.url} alt={image.alt} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-80" />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300" data-id="element-81" />
            </div>)}
        </div>

        <div className="text-center mt-12" data-id="element-82">
          <a href="#gallery" className="inline-block border-2 border-black text-black px-8 py-3 text-sm tracking-widest hover:bg-black hover:text-white transition-colors" data-id="element-83">
            VIEW FULL GALLERY
          </a>
        </div>
      </div>
    </section>;
}